import "./styles.css"

export function Background() {
  return <div className="background" />
}

export default Background
